import type { HTTPConfiguration } from "kubb";
import { authTypesEnum } from "kubb";
import type React from "react";
import KeyValueMapField from "../../../components/Forms/KeyValueMapField/KeyValueMapField";
import NewTextFormComponent from "../../../components/Forms/NewTextFormComponent";
import { HTTPExportConfigurationSchema } from "./HTTPExportConfigurationSchema";

export { HTTPExportConfigurationSchema };

export const HTTPExportInitialValues = {
  host: "",
  port: 443,
  username: "",
  password: "",
  path: undefined,
  auth_type: authTypesEnum.BASIC_AUTH,
  params: [],
} as unknown as HTTPConfiguration;

export default function HTTPExportConfigurationForm({
  namespace,
  disabled = false,
}: {
  namespace: string;
  disabled?: boolean;
}): React.ReactElement {
  const withNamespace = (fieldName: string): string => {
    return namespace ? `${namespace}.${fieldName}` : fieldName;
  };

  return (
    <>
      <h4>HTTP Configuration</h4>
      <NewTextFormComponent
        fieldName={withNamespace("host")}
        label={{ label: "URL" }}
        disabled={disabled}
      />
      {/* Port is fixed at 443 — HTTPS is required and the port is not user-configurable */}
      <NewTextFormComponent
        fieldName={withNamespace("port")}
        label={{ label: "Port" }}
        disabled={true}
      />
      <NewTextFormComponent
        fieldName={withNamespace("username")}
        label={{ label: "Username" }}
        disabled={disabled}
      />
      <NewTextFormComponent
        fieldName={withNamespace("password")}
        label={{ label: "Password" }}
        disabled={disabled}
      />
      <NewTextFormComponent
        fieldName={withNamespace("path")}
        label={{ label: "Remote path (optional)" }}
        disabled={disabled}
      />
      <KeyValueMapField
        fieldName={withNamespace("params")}
        label="POST params (optional)"
        disabled={disabled}
      />
    </>
  );
}
